// A partial overlap keeps its untouched head and tail, so re-editing one token of an insert spares the rest.
export const applyDiffToRanges = (ranges, charStart, charEndBefore, charEndAfter, addNewEdit) => {
    const delta = charEndAfter - charEndBefore;
    const next = [];
    for (const range of ranges) {
        if (range.end <= charStart) {
            next.push({ start: range.start, end: range.end });
        }
        else if (range.start >= charEndBefore) {
            next.push({ start: range.start + delta, end: range.end + delta });
        }
        else {
            if (range.start < charStart)
                next.push({ start: range.start, end: charStart });
            if (range.end > charEndBefore)
                next.push({ start: charEndAfter, end: range.end + delta });
        }
    }
    if (addNewEdit && charEndAfter > charStart) {
        next.push({ start: charStart, end: charEndAfter });
    }
    next.sort((a, b) => a.start - b.start);
    const merged = [];
    for (const range of next) {
        const last = merged[merged.length - 1];
        if (last && range.start <= last.end) {
            last.end = Math.max(last.end, range.end);
        }
        else {
            merged.push({ start: range.start, end: range.end });
        }
    }
    return merged;
};
// Snapped to token boundaries so a partial-word match can never split a rendered word.
const untouchedAffixes = (before, after) => {
    // Live chunks carry their own leading space, the editor's tokens don't, so match past it.
    const core = before.trimStart();
    const max = Math.min(core.length, after.length);
    let head = 0;
    while (head < max && core[head] === after[head])
        head++;
    // Back off to the start of the token `head` landed in; index 0 needs no separator before it.
    while (head > 0 && core[head - 1] !== " ")
        head--;
    let tail = 0;
    while (tail < max - head && before[before.length - 1 - tail] === after[after.length - 1 - tail])
        tail++;
    // A tail must open on the separator that precedes it, in both strings.
    while (tail > 0 && (before[before.length - tail] !== " " || after[after.length - tail] !== " "))
        tail--;
    return { head, tail };
};
// A chunk can be a whole phrase, so narrow to the tokens the edit actually changed.
export const computeEditCharRange = (beforeWords, afterTextLength, wordIndex, tokens) => {
    let leading = 0;
    for (let i = 0; i < wordIndex && i < beforeWords.length; i++)
        leading += beforeWords[i].length + 1;
    let trailing = 0;
    for (let i = beforeWords.length - 1; i >= wordIndex + 1; i--)
        trailing += beforeWords[i].length + 1;
    const beforeTextLength = beforeWords.join(" ").length;
    const { head, tail } = untouchedAffixes(beforeWords[wordIndex] ?? "", tokens.filter(Boolean).join(" "));
    return {
        charStart: leading + head,
        charEndBefore: beforeTextLength - trailing - tail,
        charEndAfter: afterTextLength - trailing - tail
    };
};
